
import { defineComponent, provide } from "vue";
import { tryOnMounted, tryOnUnmounted } from "@vueuse/core";
import { useRoute } from 'vue-router';
import usePageFlow from 'utils/flow/page';
import { store as OrganisationsStore } from './store';
import { store as appStore } from 'plugins/store/app';
import { store as i18nStore } from 'plugins/i18n/store';
import Builder from 'components/builder/index.vue';
import Related from 'components/ui/Related.vue';
import PinIcon from 'assets/svg/pin.svg?raw';
import LeafIcon from 'assets/svg/leaf.svg?raw';

export default defineComponent({
  name: "PageOrganisation",
  components: {
    Builder,
    Related,
  },
  setup() {
    const route = useRoute();
    const i18nLocale: Koddein.Locale = i18nStore.locale as Koddein.Locale;
    const locale = i18nLocale?.name || 'en';
    const slug = route.params.slug as string

    // remember we visit this page (for related)
    tryOnMounted(()=>   OrganisationsStore.setCurrent(slug) )
    tryOnUnmounted(()=> OrganisationsStore.unsetCurrent(slug) )

    // const category = 
    const { readyToRender, getData, onInit } = usePageFlow<PageOrganisation>({
      load(loadTwigData = false) {
        return Promise.all([
          OrganisationsStore.loadDetails(`organizations/${slug}`, slug as string, loadTwigData),
          // OrganisationsStore.loadList(loadTwigData),
        ])
        .then(([single])=>{
          if (!single) return Promise.reject() // @todo 404 ?
          return single;
        })
      },
    });

    onInit(() => {
      setTimeout(() => {
        appStore.setFooter({type: 'default'})
      }, 50);
    })

    const page = getData();
    provide('page', page);
    
    return {
      readyToRender,
      locale,
      page,
      PinIcon,
      LeafIcon,
    }
  }
})
